// This file is generated by pnpm icons:generate. Do not edit.

import {TimesLarge_Stroke2_Corner0_Rounded as CanonicalTimesLarge_Stroke2_Corner0_Rounded} from './TimesLarge'

/** @deprecated Import TimesLarge_Stroke2_Corner0_Rounded from `#/components/icons/TimesLarge` instead. */
export const TimesLarge_Stroke2_Corner0_Rounded =
  CanonicalTimesLarge_Stroke2_Corner0_Rounded
